import {FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import FileUploadPageWrapper from '../pages/file-upload/FileUploadPageWrapper'
import OverviewPageWrapper from '../pages/overview/OverviewPageWrapper'
import PotreePageWrapper from '../pages/potree/PotreePageWrapper'
import PlaygroundPageWrapper from '../pages/playground/PlaygroundPageWrapper'
import WaterstandenPageWrapper from '../pages/waterstanden/WaterstandenPageWrapper'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        {/* <Route path='dashboard' element={<DashboardWrapper />} /> */}
        <Route path='/fileupload' element={<FileUploadPageWrapper />} />
        <Route path='/overview' element={<OverviewPageWrapper />} />
        <Route path='/waterstanden' element={<WaterstandenPageWrapper />} />
        <Route path='/dashboard' element={<PotreePageWrapper />} />
        <Route path='/playground' element={<PlaygroundPageWrapper />} />
        {/* Lazy Modules */}
        {/* <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
          /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
